import { SplixerResourceInterface } from './splixer-resource.interface';
import { Uuid } from '@hidat/huijs-common';
import { ResourceConfig } from '@hidat/huijs-resource';
import { SplixerResourceTypes } from './splixer-resource-types';

export const PlaybackSessionConfig = new ResourceConfig(
  SplixerResourceTypes.PlaybackSession,
  'sessions',
);

export interface PlaybackSessionInterface extends SplixerResourceInterface<number> {
  uid: Uuid | undefined;
  source: string | undefined;
  instanceId: number | undefined;
  listenerId: Uuid | undefined;
  sessionPathId: number | undefined;
  stationId: number | undefined;
  ipAddress?: string;
  tz: string | undefined;
  tzOffset: number | undefined;
}
